import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faCaretRight, faFilePdf, faTrashAlt, faSave, faFileWord } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import _ from 'lodash';
import Axios from 'axios';
import {Button} from 'react-bootstrap';
import {Alert, Logout, BaseURL, DConnect, DecryptData, PostOptions} from '../../components/Config';

function Expenditure(props){
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [financials, setFinancials] = useState(props.financials);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [expenditures, setExpenditures] = useState(props.expenditures);
    const [expenditure, setExpenditure] = useState({id:0, app_num:props.registration.app_num, item:13, item_other:'', quantity:0, unitcost:0, amount:0, createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    const [dropdowns, setDropdowns] = useState({'expenditure':[]});
    const [modalstatus , setModalStatus] =  useState(false);
    const [save, setSave] = useState(false);
    const [doc1, setDoc1] = useState({document:'', fileUrl:'', ex:''});
    const [doc2, setDoc2] = useState({document:'', fileUrl:'', ex:''});
    const [doc3, setDoc3] = useState({document:'', fileUrl:'', ex:''});
    const [doc4, setDoc4] = useState({document:'', fileUrl:'', ex:''});

    const curformat = new Intl.NumberFormat("en-GB", { maximumFractionDigits: 2, minimumFractionDigits: 2 });

    useEffect(() => {
        props.getProps(props);
        setRegistration(props.registration);
        setFinancials(props.financials);
        setExpenditures(props.expenditures);
        setDropdowns(props.dropdowns);
        setBusinessDetails(props.businessDetails)

        getExpenditure(financials.app_num);
        
    }, [props.financials]);

    const clickTrigger = (id) =>{
        $('#'+id).click();
    }

    const getExpenditure = (appnum) => {
            setAppnum(appnum);
            
      
    }

    const setAppnum = (appnum) => {
        let expendit = expenditures.map(expend => {
            expend.app_num = appnum;
            return expend;
        });

        setExpenditures(expendit);
    }

    const handleChange = (e, i) => {
        e.preventDefault();

        const {name, value} = e.target;

        let exp = [...expenditures];

        if(['quantity','unitcost'].includes(name) && value < 0){
            exp[i][name] = 0;
        }else{
            exp[i][name] = value;
        }
        

        if(['quantity','unitcost'].includes(name)){
            exp[i].amount = parseInt(exp[i].quantity) * parseFloat(exp[i].unitcost);
        }

        setExpenditures(exp);
    }
    const addExpenditureLine = (e) => {
        e.preventDefault();

        expenditures.push(expenditure);
        props.handleChange(8, expenditures);

        hideDialog();
    }

    const deleteExpenditure = (idx) => {
        let newExpenditure = [...expenditures];

        newExpenditure.splice(idx,1);
        setExpenditures(newExpenditure);
        props.handleChange(8, newExpenditure);
    } 

    const hideDialog = () => {
        setModalStatus(false);
        
        setExpenditure({id:0, app_num:props.registration.app_num, item:13, item_other:'', quantity:0, unitcost:0, amount:0, createdon:new Date(), modifiedon:new Date(), modifiedby:''});
    }

    const fileChange = (e) => {
        e.preventDefault();

        const {name, value} = e.target;

        let reader = new FileReader();
        let file = e.target.files[0];
        let ext = file.name.split('.');

        setFinancials(prevState => ({...prevState, [name]:`${businessDetails.app_num}_${name}.${ext[ext.length-1]}`}));

        reader.onloadend = () => {
            let image = {document:file, fileUrl: reader.result, ext:ext[ext.length-1]};
            
            if(name === 'proformainvoice1'){
                setDoc1(image);
            }else if(name === 'proformainvoice2'){
                setDoc2(image);
            }else if(name === 'proformainvoice3'){
                setDoc3(image);
            }else{
                setDoc4(image);
            }
        }

        reader.readAsDataURL(file);
    }


    const submitForm = (e) => {
        e.preventDefault();
      
        if((_.sumBy(expenditures, itm => Number(itm.amount))) != financials.getp3requested_amt){
            Alert({title:'Expenditure',message:`Requested Grant Amount and Total Expected Expenditure must be the same amount`, buttons:[{label:'Ok'}]});
            return;
        }

        if([2, 3, "2", "3"].includes(expenditures[0].item) || [2, 3, "2", "3"].includes(expenditures[1].item) || [2, 3, "2", "3"].includes(expenditures[2].item)){
          if([3,"3"].includes(expenditures[0].item) || [3,"3"].includes(expenditures[1].item) || [3,"3"].includes(expenditures[2].item)){
            if(financials.proformainvoice1 == null || financials.proformainvoice1 == ''){
                Alert({title:'Proforma Invoice',message:'Please Upload Proforma Invoice 1 to proceed...', buttons:[{label:'Ok'}]});
                return;
            }

            if(financials.proformainvoice2 == null || financials.proformainvoice2 == ''){
                Alert({title:'Proforma Invoice',message:'Please Upload Proforma Invoice 2 to proceed...', buttons:[{label:'Ok'}]});
                return;
            }

            if(financials.proformainvoice3 == null || financials.proformainvoice3 == ''){
                Alert({title:'Proforma Invoice',message:'Please Upload Proforma Invoice 3 to proceed...', buttons:[{label:'Ok'}]});
                return;
            }
          }
          if([2,"2"].includes(expenditures[0].item) || [2,"2"].includes(expenditures[1].item) || [2,"2"].includes(expenditures[2].item)){
            if(financials.proformainvoice4 == null || financials.proformainvoice4 == ''){
                Alert({title:'Proforma Invoice',message:'Please Upload Raw Materials proforma invoice to proceed...', buttons:[{label:'Ok'}]});
                return;
            }
          }
        }
        //alert(JSON.stringify(expenditures))
        props.handleChange(8, expenditures);
        Axios(PostOptions('POST', expenditures, 'expenditure/bulk')).then(res => {
            let resdata = DecryptData(res.data);
            if(resdata.id !== undefined){
                expenditures['id'] = resdata.id;
                props.handleChange(8, expenditures);
            }
          props.handleChange(7, financials);
        //   alert(JSON.stringify(financials))
        let options = (financials.id == 0) ? PostOptions('POST', financials, 'financing')
        : PostOptions('PUT', financials, `financing/${financials.id}`);
        
        Axios(options).then(res => {
            let resdata = DecryptData(res.data);

            let formData = new FormData();
            formData.append('filename', financials.proformainvoice1);
            formData.append('cert', doc1.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData).then(resp => { });

            let formData2 = new FormData();
            formData2.append('filename', financials.proformainvoice2);
            formData2.append('cert', doc2.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData2).then(resp => { });

            let formData3 = new FormData();
            formData3.append('filename', financials.proformainvoice3);
            formData3.append('cert', doc3.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData3).then(resp => { });

            let formData4 = new FormData();
            formData4.append('filename', financials.proformainvoice4);
            formData4.append('cert', doc4.document);
            Axios.post(`${BaseURL()}v1.0/fileupload`, formData4).then(resp => { });

            if(resdata.id !== undefined){
                financials['id'] = resdata.id;
                props.handleChange(7, financials);
            }

            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 7 ? 7: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
             })
        }).catch(error => {Alert({title:'Financials',message:error.message, buttons:[{label:'Ok'}]}); });
        }).catch(error => {
            Alert({title:'Expenditure',message:error.message, buttons:[{label:'Ok'}]});
        });

        if(save){
        Logout()
        window.location.reload()
        }else{
        props.doNavigate(props,7,1);
        }
        
    }

    return(
        <div className="content">
            <h5>Expected Grant <span>Expenditure</span></h5><br />
            <form id="frmExpenditure" method="POST" onSubmit={submitForm}>
                <div className="row">
                <div className="col-12">
                        <hr />
                        {/* <label>Grant Expenditures</label> */}
                        <a onClick={addExpenditureLine} className="btn btn-sm btn-primary" style={{float:'right', marginBottom: 6}}>Add Expenditure Line</a>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered table-striped table-condensed d-none d-md-block d-sm-block d-sm-none">
                            <thead>
                                <th scope="col">No.</th>
                                <th scope="col" style={{width:'40%'}}>Item</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Unit Cost (GHS)</th>
                                <th scope="col">Amount</th>
                                <th scope="col"></th>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="row">1.</th>
                                    <td>
                                        <select className="form-control custom-select" id="item1" name="item" required={expenditures[0].quantity != 0}
                                            value={expenditures[0].item == 0 ? '': expenditures[0].item} onChange={(e)=>handleChange(e,0)}>
                                            <option value=""> -- Choose Item -- </option>
                                            {dropdowns.expenditure.map(exp => (
                                                <option value={exp.ivalue}>{exp.iname}</option>
                                            ))}
                                        </select>
                                        {expenditures[0].item == '13' &&
                                        <input type="text" class="form-control" id="item_other1" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,0)} value={expenditures[0].item_other} />}
                                    </td>
                                    <td><input type="number" step="any" class="form-control" id="quantity1" name="quantity" value={expenditures[0].quantity} onChange={(e)=>handleChange(e,0)} /></td>
                                    <td><input type="number" step="any" class="form-control" id="unitcost1" name="unitcost" value={expenditures[0].unitcost} onChange={(e)=>handleChange(e,0)} /></td>
                                    <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[0].amount)}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th scope="row">2.</th>
                                    <td>
                                        <select className="form-control custom-select" id="item2" name="item" required={expenditures[1].quantity != 0}
                                            value={expenditures[1].item == 0 ? '': expenditures[1].item} onChange={(e)=>handleChange(e,1)}>
                                            <option value=""> -- Choose Item -- </option>
                                            {dropdowns.expenditure.map(exp => (
                                                <option value={exp.ivalue}>{exp.iname}</option>
                                            ))}
                                        </select>
                                        {expenditures[1].item == '13' &&
                                        <input type="text" class="form-control" id="item_other2" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,1)} value={expenditures[1].item_other} />}
                                    </td>
                                    <td><input type="number" step="any" class="form-control" id="quantity2" name="quantity" value={expenditures[1].quantity} onChange={(e)=>handleChange(e,1)} /></td>
                                    <td><input type="number" step="any" class="form-control" id="unitcost2" name="unitcost" value={expenditures[1].unitcost} onChange={(e)=>handleChange(e,1)} /></td>
                                    <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[1].amount)}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th scope="row">3.</th>
                                    <td>
                                        <select className="form-control custom-select" id="item3" name="item" required={expenditures[2].quantity != 0}
                                            value={expenditures[2].item == 0 ? '': expenditures[2].item} onChange={(e)=>handleChange(e,2)}>
                                            <option value=""> -- Choose Item -- </option>
                                            {dropdowns.expenditure.map(exp => (
                                                <option value={exp.ivalue}>{exp.iname}</option>
                                            ))}
                                        </select>
                                        {expenditures[2].item == '13' &&
                                        <input type="text" class="form-control" id="item_other2" name="item_other" placeholder="Specify" 
                                            onChange={(e)=>handleChange(e,2)} value={expenditures[2].item_other} />}
                                    </td>
                                    <td><input type="number" step="any" class="form-control" id="quantity3" name="quantity" value={expenditures[2].quantity} onChange={(e)=>handleChange(e,2)} /></td>
                                    <td><input type="number" step="any" class="form-control" id="unitcost3" name="unitcost" value={expenditures[2].unitcost} onChange={(e)=>handleChange(e,2)} /></td>
                                    <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[2].amount)}</td>
                                    <td></td>
                                </tr>
                                {expenditures.map((exp, idx) => {
                                    if(idx >= 3){
                                    return(
                                <tr>
                                <th scope="row">{(idx + 1)}.</th>
                                <td>  
                                    <input type="text" class="form-control" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,idx)} value={expenditures[idx].item_other} required />
                                </td>
                                <td><input type="number" step="any" class="form-control" name="quantity" value={expenditures[idx].quantity} onChange={(e)=>handleChange(e,idx)} /></td>
                                <td><input type="number" step="any" class="form-control" name="unitcost" value={expenditures[idx].unitcost} onChange={(e)=>handleChange(e,idx)} /></td>
                                <td className="text-right" style={{lineHeight:'42px'}}>{curformat.format(expenditures[idx].amount)}</td>
                                <td><FontAwesomeIcon icon={faTrashAlt} size="lg" className="text-danger"  style={{cursor:'pointer'}} onClick={() => deleteExpenditure(idx)} /></td>
                            </tr>
                                    )}})}
                                <tr>
                                    <th scope="row"></th>
                                    <th>Total Expected Expenditure</th>
                                    <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.quantity)))}</th>
                                    <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.unitcost)))}</th>
                                    <th className="text-right">{curformat.format(_.sumBy(expenditures, itm => Number(itm.amount)))}</th>
                                </tr>
                            </tbody>
                        </table>
                        <div className="d-lg-none d-md-none d-sm-none">
                            <ul style={{listStyle:'none'}}>
                                <li>Item 1: 
                                    <select className="form-control custom-select" id="item1" name="item" 
                                        value={expenditures[0].item} onChange={(e)=>handleChange(e,0)}>
                                        <option value=""> -- Choose Item -- </option>
                                        {dropdowns.expenditure.map(exp => (
                                            <option value={exp.ivalue}>{exp.iname}</option>
                                        ))}
                                    </select>  
                                    {expenditures[0].item == '13' &&
                                        <input type="text" class="form-control" id="item_other1" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,0)} value={expenditures[0].item_other} />}
                                </li>
                                <li>&nbsp; </li>
                                <li>Quantity: <input type="number" step="any" class="form-control" id="quantity1" name="quantity" value={expenditures[0].quantity} onChange={(e)=>handleChange(e,0)} /></li>
                                <li>Unit Cost (GHS): <input type="number" step="any" class="form-control" id="unitcost1" name="unitcost" value={expenditures[0].unitcost} onChange={(e)=>handleChange(e,0)} /></li>
                                <li>Amount: {curformat.format(expenditures[0].amount)}</li>
                            </ul><hr />
                            <ul style={{listStyle:'none'}}>
                                <li>Item 2: 
                                    <select className="form-control custom-select" id="item2" name="item" 
                                        value={expenditures[1].item} onChange={(e)=>handleChange(e,1)}>
                                        <option value=""> -- Choose Item -- </option>
                                        {dropdowns.expenditure.map(exp => (
                                            <option value={exp.ivalue}>{exp.iname}</option>
                                        ))}
                                    </select>  
                                    {expenditures[1].item == '13' &&
                                        <input type="text" class="form-control" id="item_other2" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,1)} value={expenditures[1].item_other} />}
                                </li>
                                <li>&nbsp; </li>
                                <li>Quantity: <input type="number" step="any" class="form-control" id="quantity2" name="quantity" value={expenditures[1].quantity} onChange={(e)=>handleChange(e,1)} /></li>
                                <li>Unit Cost (GHS): <input type="number" step="any" class="form-control" id="unitcost2" name="unitcost" value={expenditures[1].unitcost} onChange={(e)=>handleChange(e,1)} /></li>
                                <li>Amount: {curformat.format(expenditures[1].amount)}</li>
                            </ul><hr />
                            <ul style={{listStyle:'none'}}>
                                <li>Item 3: 
                                    <select className="form-control custom-select" id="item3" name="item" 
                                        value={expenditures[2].item} onChange={(e)=>handleChange(e,2)}>
                                        <option value=""> -- Choose Item -- </option>
                                        {dropdowns.expenditure.map(exp => (
                                            <option value={exp.ivalue}>{exp.iname}</option>
                                        ))}
                                    </select>  
                                    {expenditures[1].item == '13' &&
                                        <input type="text" class="form-control" id="item_other3" name="item_other" placeholder="Specify" 
                                        onChange={(e)=>handleChange(e,2)} value={expenditures[2].item_other} />}
                                </li>
                                <li>&nbsp; </li>
                                <li>Quantity: <input type="number" step="any" class="form-control" id="quantity3" name="quantity" value={expenditures[2].quantity} onChange={(e)=>handleChange(e,2)} /></li>
                                <li>Unit Cost (GHS): <input type="number" step="any" class="form-control" id="unitcost3" name="unitcost" value={expenditures[2].unitcost} onChange={(e)=>handleChange(e,2)} /></li>
                                <li>Amount: {curformat.format(expenditures[2].amount)}</li>
                            </ul><hr />
                            <ul style={{listStyle:'none'}}>
                                <li><b>Total Expenditure</b></li>
                                <li>&nbsp;</li>
                                <li>Quantity: {curformat.format(expenditures[0].quantity+expenditures[1].quantity+expenditures[2].quantity)}</li>
                                <li>Unit Cost (GHS): {curformat.format(expenditures[0].unitcost+expenditures[1].unitcost+expenditures[2].unitcost)}</li>
                                <li>Amount: {curformat.format(expenditures[0].amount+expenditures[1].amount+expenditures[2].amount)}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="row">
                       
                        <div className="col-xs-12 col-md-6 ">
                        {expenditures.filter(row => row.item == 3 && row.amount > 5000).length > 0 && <><div className="form-group">
                                <label for="proformainvoice1">Upload Purchase of Equipment proforma invoice 1:</label><span className="required">*</span>
                                <br /> <small className="text-primary"></small>
                                <div id="proformainvoice1Con" onClick={() => clickTrigger("proformainvoice1")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                                {financials.proformainvoice1 === '' ? 'Click here to add' : 
                                (![undefined,null].includes(financials.proformainvoice1) && (financials.proformainvoice1).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(financials.proformainvoice1) && (financials.proformainvoice1).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc1.fileUrl !== '') ? doc1.fileUrl : (financials.proformainvoice1 !== null) ? `${BaseURL()}static/${financials.proformainvoice1}`:``} style={{height:'120px'}} /> }
                                </div>
                                <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .docx, .doc, .pdf" id="proformainvoice1" name="proformainvoice1" style={{display:'none'}} 
                                onChange={fileChange} />
                            </div> 
                            <div className="form-group">
                            <label for="proformainvoice2">Upload Purchase of Equipment proforma invoice 2:</label><span className="required">*</span>
                            <br /> <small className="text-primary"></small>
                            <div id="proformainvoice2Con" onClick={() => clickTrigger("proformainvoice2")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                                {financials.proformainvoice2 === '' ? 'Click here to add' : 
                                (![undefined,null].includes(financials.proformainvoice2) && (financials.proformainvoice2).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(financials.proformainvoice2) && (financials.proformainvoice2).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc2.fileUrl !== '') ? doc2.fileUrl : (financials.proformainvoice2 !== null) ? `${BaseURL()}static/${financials.proformainvoice2}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .docx, .doc, .pdf" id="proformainvoice2" name="proformainvoice2" style={{display:'none'}} 
                            onChange={fileChange} />
                        </div></>}    
                        </div>
                        <div className="col-xs-12 col-md-6 ">
                        {expenditures.filter(row => row.item == 3 && row.amount > 5000).length > 0 && <div className="form-group"><span className="required">*</span>
                            <label for="proformainvoice3">Upload Purchase of Equipment proforma invoice 3:</label>
                            <br /> <small className="text-primary"></small>
                            <div id="proformainvoice3Con" onClick={() => clickTrigger("proformainvoice3")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                            {financials.proformainvoice3 === '' ? 'Click here to add' : 
                                (![undefined,null].includes(financials.proformainvoice3) && (financials.proformainvoice3).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(financials.proformainvoice3) && (financials.proformainvoice3).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc3.fileUrl !== '') ? doc3.fileUrl : (financials.proformainvoice3 !== null) ? `${BaseURL()}static/${financials.proformainvoice3}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .docx, .doc, .pdf" id="proformainvoice3" name="proformainvoice3" style={{display:'none'}} 
                            onChange={fileChange} />
                            
                        </div>}
                        {expenditures.filter(row => row.item == 2).length > 0 && <div className="form-group">
                            <label for="proformainvoice4">Upload Raw Materials proforma invoice:</label><span className="required">*</span>
                            <br /> <small className="text-primary"></small>
                            <div id="proformainvoice4Con" onClick={() => clickTrigger("proformainvoice4")} className="border border-primary text-center p-1" style={{cursor:'pointer',minHeight:'120px'}}>
                            {financials.proformainvoice4 === '' ? 'Click here to add' : 
                                (![undefined,null].includes(financials.proformainvoice4) && (financials.proformainvoice4).includes('pdf')) 
                                ? <FontAwesomeIcon icon={faFilePdf} style={{fontSize:'120px'}} />
                                :(![undefined,null].includes(financials.proformainvoice4) && (financials.proformainvoice4).includes('docx'))
                                ? <FontAwesomeIcon icon={faFileWord} style={{fontSize:'120px'}} />
                                : <img src={(doc4.fileUrl !== '') ? doc4.fileUrl : (financials.proformainvoice4 !== null) ? `${BaseURL()}static/${financials.proformainvoice4}`:``} style={{height:'120px'}} /> }
                            </div>
                            <input type="file" className="form-control" accept=".jpg, .jpeg, .png, .docx, .doc, .pdf" id="proformainvoice4" name="proformainvoice4" style={{display:'none'}} 
                            onChange={fileChange} />
                            
                        </div>}
                        </div>
                </div>        
            </form>
            <button className="btn btn-bg btn-outline text-white" style={{padding:'10px 20px',borderRadius: '20px', marginTop: '25px'}} onClick={() => props.doNavigate(props,5,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
            <button type="submit" form="frmExpenditure"  className="btn btn-bg btn-outline text-white float-right" style={{padding:'10px 20px', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px'}}>Save &amp; Next &nbsp; <FontAwesomeIcon icon={faCaretRight} size="lg"  /></button>
            <button type="submit" form="frmExpenditure" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>
        </div>
    )
}

export default Expenditure;